export enum BlockHrefTargetEnum {
  SELF_HREF_TARGET = 0,
  BLANK_HREF_TARGET = 1,
  SELF_HREF_TARGET_STRING = '_self',
  BLANK_HREF_TARGET_STRING = '_blank',
}
